import { render } from "./allmeasurement.vue?vue&type=template&id=06586ffc"
import script from "./allmeasurement.vue?vue&type=script&lang=js"
export * from "./allmeasurement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__